export const LOAD_DISHES = "LOAD_DISHES";
export const DISHES_LOADING = "DISHES_LOADING";